import React, { useLayoutEffect, useState } from "react";
import { Link } from "react-router-dom";
import { NetworkConfig } from "src/network/NetworkConfig";
import styles from "./Tile.module.css";
import { CSSTransition } from "react-transition-group";

interface TileProps {
    label: string;
    icon?: string;
    to: string;
    id: string;
    index?: number;
}

export const Tile = (props: TileProps) => {
    const [fadeTile, setFadeTile] = useState(false);
    const { label, icon, to, id, index } = props;

    useLayoutEffect(() => {
        window.setTimeout(() => setFadeTile(true), (index ?? 0) * 80);
    }, [setFadeTile, index]);

    return (
        <div className={styles.TileOuter}>
            <CSSTransition key={id} in={fadeTile} timeout={300} classNames="fade" unmountOnExit>
                <div className={styles.Tile}>
                    <Link to={to} className={styles.TileInner}>
                        <img
                            className={styles.TileIcon}
                            src={`${NetworkConfig.iconsUrl}/${icon || "unknown"}.svg`}
                            alt={icon}
                        />
                        <div className={styles.TileLabel}>{label}</div>
                    </Link>
                </div>
            </CSSTransition>
        </div>
    );
};
